import type { FC, ImgHTMLAttributes } from 'react';

interface HelpImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  url: string;
  width?: string | number;
}

export const HelpImage: FC<HelpImageProps> = ({ url, width, ...rest }) => {
  return (
    <figure>
      <img
        src={url}
        style={{
          width: width,
          maxHeight: '70vh',
        }}
        draggable={false}
        {...rest}
      />
    </figure>
  );
};
